const material = [
  { id: 1, type: "material", label: "All Aluminum" },
  { id: 2, type: "material", label: "Clad Exterior/Wood Interior" },
  { id: 3, type: "material", label: "All Wood" },
];

export { material };
